export default __webpack_public_path__ + "static/media/chat.021cf5da.svg";